import {
  easeInOutSine,
  smoothstep,
  clamp,
  w, h,
  frame,
  frameN,
  setFrameN,
  getCanvasSize,
  setupCommon,
  drawCommon,
  make,
} from '../js/common.js';

export function setup() {
	setupCommon();
}

const count = 40;
const prev = [];
export function draw() {
	drawCommon();
	background(98);

	if (prev.length > count - 1)
		prev.shift();

	if (prev.length < count) {
		for (let i = 0; i < count - prev.length; i++) {
			const ls = [];
			for (let y = 0.05; y < 1; y += 0.05) {
				const l = [];
				for (let x = 0.02; x < 0.99; x += 0.01) {
					const z = frameN * 6 + i * 0.01;
					const n = (noise(x * 4.9 + 2 * Math.cos(frameN * TAU), y * 3.1, z) * 2 - 1) * 0.09;
					let y2 = y + n * smoothstep(0, 0.9, y) * x * x * 2;
					l.push([x, y2]);
				}
				ls.push(l);
			}
			prev.push(ls);
		}
	}


	const sat = 80 + 8 * Math.sin(frameN * TAU + PI);
	const bri = 70 + 5 * Math.sin(frameN * TAU + HALF_PI);
	noFill();
	prev.forEach(ls => {
		ls.forEach((l, j) => {
			const hue = 190 + 20 * Math.sin(frameN * TAU + j * 0.08);
			stroke(hue, sat, bri, 0.2);

			beginShape();
			l.forEach(([x, y]) => vertex(w(x), h(y)));
			endShape();
		});
	});
}
